import { Loader2, Database } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface VectorizeStatusBadgeProps {
  chunkCount: number | null; // null = loading, 0 = not vectorized, >0 = vectorized
  isVectorizing?: boolean;
  onClick?: () => void;
}

export default function VectorizeStatusBadge({ chunkCount, isVectorizing, onClick }: VectorizeStatusBadgeProps) {
  if (isVectorizing) {
    return (
      <Badge variant="secondary" className="gap-1">
        <Loader2 className="w-3 h-3 animate-spin" />
        Processing...
      </Badge>
    );
  }

  if (chunkCount === null) {
    return <span className="text-muted-foreground">—</span>;
  }

  if (chunkCount === 0) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <Badge
      className="gap-1 bg-green-100 text-green-800 hover:bg-green-200 border-green-200 cursor-pointer dark:bg-green-900/30 dark:text-green-400 dark:border-green-800"
      onClick={onClick}
    >
      <Database className="w-3 h-3" />
      {chunkCount}
    </Badge>
  );
}
